/**
 * Zzzing Guest API
 * Zzzing Guest API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { LinkReservationDetails } from '../model/models';
import { LinkReservationParams } from '../model/models';
import { ReservationCheckInDetailsUpdateParams } from '../model/models';
import { ReservationDetails } from '../model/models';
import { ReservationSummary } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class GuestReservationsService {

    protected basePath = 'https://dev.zzzing.com/api/guest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Retrieves a list of linked reservations summaries
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLinkedReservations(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<ReservationSummary>>;
    public getLinkedReservations(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<ReservationSummary>>>;
    public getLinkedReservations(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<ReservationSummary>>>;
    public getLinkedReservations(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (zzzing_auth) required
        credential = this.configuration.lookupCredential('zzzing_auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<ReservationSummary>>(`${this.configuration.basePath}/reservations`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves a reservation
     * Retrieves the information related to a reservation
     * @param bookingRef Booking Reference
     * @param checkInDate The check in date of this reservation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReservation(bookingRef: string, checkInDate: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LinkReservationDetails>;
    public getReservation(bookingRef: string, checkInDate: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LinkReservationDetails>>;
    public getReservation(bookingRef: string, checkInDate: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LinkReservationDetails>>;
    public getReservation(bookingRef: string, checkInDate: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (bookingRef === null || bookingRef === undefined) {
            throw new Error('Required parameter bookingRef was null or undefined when calling getReservation.');
        }
        if (checkInDate === null || checkInDate === undefined) {
            throw new Error('Required parameter checkInDate was null or undefined when calling getReservation.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (checkInDate !== undefined && checkInDate !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>checkInDate, 'check_in_date');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<LinkReservationDetails>(`${this.configuration.basePath}/unprot/reservations/${encodeURIComponent(String(bookingRef))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves the check-in information for an existing reservation
     * Retrieves the check-in information related to a reservation
     * @param bookingRef Booking Reference
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReservationCheckInDetails(bookingRef: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/html; charset&#x3D;utf-8'}): Observable<string>;
    public getReservationCheckInDetails(bookingRef: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/html; charset&#x3D;utf-8'}): Observable<HttpResponse<string>>;
    public getReservationCheckInDetails(bookingRef: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/html; charset&#x3D;utf-8'}): Observable<HttpEvent<string>>;
    public getReservationCheckInDetails(bookingRef: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/html; charset&#x3D;utf-8'}): Observable<any> {
        if (bookingRef === null || bookingRef === undefined) {
            throw new Error('Required parameter bookingRef was null or undefined when calling getReservationCheckInDetails.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/html; charset=utf-8'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<string>(`${this.configuration.basePath}/unprot/reservations/${encodeURIComponent(String(bookingRef))}/check-in`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves the details of a linked reservation
     * @param bookingRef Booking Reference
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReservationDetails(bookingRef: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ReservationDetails>;
    public getReservationDetails(bookingRef: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ReservationDetails>>;
    public getReservationDetails(bookingRef: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ReservationDetails>>;
    public getReservationDetails(bookingRef: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (bookingRef === null || bookingRef === undefined) {
            throw new Error('Required parameter bookingRef was null or undefined when calling getReservationDetails.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (zzzing_auth) required
        credential = this.configuration.lookupCredential('zzzing_auth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ReservationDetails>(`${this.configuration.basePath}/reservations/${encodeURIComponent(String(bookingRef))}/details`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves a document related to a reservation. This allows guests sharing the same reservation to view the documents.
     * @param bookingRef Booking Reference
     * @param documentNumber Document Number
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReservationDocument(bookingRef: string, documentNumber: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf'}): Observable<Blob>;
    public getReservationDocument(bookingRef: string, documentNumber: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf'}): Observable<HttpResponse<Blob>>;
    public getReservationDocument(bookingRef: string, documentNumber: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf'}): Observable<HttpEvent<Blob>>;
    public getReservationDocument(bookingRef: string, documentNumber: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf'}): Observable<any> {
        if (bookingRef === null || bookingRef === undefined) {
            throw new Error('Required parameter bookingRef was null or undefined when calling getReservationDocument.');
        }
        if (documentNumber === null || documentNumber === undefined) {
            throw new Error('Required parameter documentNumber was null or undefined when calling getReservationDocument.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/pdf'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/reservations/${encodeURIComponent(String(bookingRef))}/documents/${encodeURIComponent(String(documentNumber))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Link reservation to a guest
     * @param bookingRef Booking Reference
     * @param checkInDate The check in date of this reservation
     * @param linkReservationParams Link Reservation Details
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public linkReservation(bookingRef: string, checkInDate: string, linkReservationParams: LinkReservationParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LinkReservationDetails>;
    public linkReservation(bookingRef: string, checkInDate: string, linkReservationParams: LinkReservationParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LinkReservationDetails>>;
    public linkReservation(bookingRef: string, checkInDate: string, linkReservationParams: LinkReservationParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LinkReservationDetails>>;
    public linkReservation(bookingRef: string, checkInDate: string, linkReservationParams: LinkReservationParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (bookingRef === null || bookingRef === undefined) {
            throw new Error('Required parameter bookingRef was null or undefined when calling linkReservation.');
        }
        if (checkInDate === null || checkInDate === undefined) {
            throw new Error('Required parameter checkInDate was null or undefined when calling linkReservation.');
        }
        if (linkReservationParams === null || linkReservationParams === undefined) {
            throw new Error('Required parameter linkReservationParams was null or undefined when calling linkReservation.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (checkInDate !== undefined && checkInDate !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>checkInDate, 'check_in_date');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<LinkReservationDetails>(`${this.configuration.basePath}/reservations/${encodeURIComponent(String(bookingRef))}`,
            linkReservationParams,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update the check-in information of a reservation
     * Update the check-in information related to a reservation
     * @param bookingRef Booking Reference
     * @param reservationCheckInDetailsUpdateParams Check In Details Update Parameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateReservationCheckInDetails(bookingRef: string, reservationCheckInDetailsUpdateParams: ReservationCheckInDetailsUpdateParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public updateReservationCheckInDetails(bookingRef: string, reservationCheckInDetailsUpdateParams: ReservationCheckInDetailsUpdateParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public updateReservationCheckInDetails(bookingRef: string, reservationCheckInDetailsUpdateParams: ReservationCheckInDetailsUpdateParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public updateReservationCheckInDetails(bookingRef: string, reservationCheckInDetailsUpdateParams: ReservationCheckInDetailsUpdateParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        if (bookingRef === null || bookingRef === undefined) {
            throw new Error('Required parameter bookingRef was null or undefined when calling updateReservationCheckInDetails.');
        }
        if (reservationCheckInDetailsUpdateParams === null || reservationCheckInDetailsUpdateParams === undefined) {
            throw new Error('Required parameter reservationCheckInDetailsUpdateParams was null or undefined when calling updateReservationCheckInDetails.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.patch<any>(`${this.configuration.basePath}/unprot/reservations/${encodeURIComponent(String(bookingRef))}/check-in`,
            reservationCheckInDetailsUpdateParams,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
